import { breakpoints } from "./utilities.js";
import { getSearchBarOptions } from "./search-bar.js";
import { submit as dynamicSearchSubmit } from "./dynamic-search.js"

const init = () => {
    //searchParams/queryString values are mapped to elements by backend, no need for any JS here
    const searchBlock = document.querySelectorAll('#form-searchblock, #form-property-bookingwidget')[0];
    const isSearchResultsPage = searchBlock?.classList.contains('js-dynamic-search');

    if (searchBlock) {
        const loadPickers = async () => {
            if ($('.js-airport-picker-trigger').length) {
                const importedAirport = await import(`./airport-picker.js`);
                importedAirport.default()
            }
            if ($('.js-date-picker-wrapper').length) {
                const importedDate = await import(`./date-picker.js`);
                importedDate.default()
            }
            if ($('.js-folks-selector-trigger').length) {
                const importedFolks = await import(`./folks-selector.js`);
                importedFolks.default()
            }
            if ($('.js-destination-picker-trigger').length) {
                const importedDesintation = await import(`./destination-picker.js`);
                importedDesintation.default()
            }
            if ($('.js-accommodation-only-checkbox').length) {
                const accommodationOnly = await import(`./accommodation-only.js`);
                accommodationOnly.default()
            }

            getSearchBarOptions()
            if (isSearchResultsPage) {
                updateUrlSearchParams()
            }
        }

        loadPickers();

        $(searchBlock).on('click', '.js-tabs-links', e => {
            [...searchBlock.querySelectorAll('.js-tabs-links-link')].forEach((e) => e.classList.remove('active'));
            e.target.classList.add('active');
            const multiroomType = e.target.dataset.multiroom;

            window.site.body.trigger({
                type: 'pickersTabChange',
                tabTarget: e.target,
                multiroomType
            });

            searchBlock.querySelector('input[name="accommodationSearchType"]').value = multiroomType;

            getSearchBarOptions();
            if ($(searchBlock).hasClass('js-dynamic-search')) {
                dynamicSearchSubmit(false);
            }
            updateUrlSearchParams()
        });
    }
}

const positionPickerPanel = ($pickerBlock, $triggerEl) => {
    if (window.innerWidth > breakpoints.tablet) {
        const { top } = $triggerEl.position();
        const spacing = $triggerEl.height() + top + 48; // 48px of gap

        $pickerBlock.find('.c-pickers-panel').css({ top: `${Math.floor(spacing)}px` });
    }
    else {
        // On mobile the panel becomes a modal, so dont alter css value
        $pickerBlock.find('.c-pickers-panel').css({ top: '' });
    }
}

const updateUrlSearchParams = () => {
    // On Submit/ajax load, update URL to give accurate serchParams for url sharing/bookmarking
    const $searchBlock = $('#form-searchblock');
    const inputs = $searchBlock.find('input, select').filter(function() {
        const inputName = $(this).attr("name");
        return !(inputName && inputName.startsWith('facilities'));
    }).serialize();

    history.replaceState(null, '', `?${inputs}`);
}

function generateGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

export { updateUrlSearchParams, generateGuid, positionPickerPanel }
export default init;
